import React, { FC, useRef, useState } from 'react';
import { IThemeSwiperRef, ThemeSwiper } from '@base/lib/ThemeSwiper';
import cn from 'classnames';
import styles from './index.module.less';
import { IFeatureSwiperReviews, IReview } from 'mod/feature/interface'
import { Rate } from '@base/lib/Rate'
import ReviewDetailModal from '@app/features/ReviewDetailModal';
import homeStyles from '@app/shop/index.module.less'
import { getModuleCode, getModuleElementId, getWrapStyle } from 'base/utils/features'
import titleStyles from 'app/styles/modules/title.module.less'
import ModuleTitle from '@base/lib/ModuleTitle'
import { stringReplaceMiddleChars } from 'base/utils/string'
import Image from '@base/lib/ThemeImage';

declare interface IProps {
    data: IFeatureSwiperReviews;
}

const SwiperReviews: FC<IProps> = (props) => {
    const { data } = props

    const moduleCode = getModuleCode(data);
    const moduleElementId = getModuleElementId(data);

    const swiperRef = useRef<IThemeSwiperRef>(null);
    const [reviewItem, setReviewItem] = useState<IReview>();
    const [detailVisible, setDetailVisible] = useState<boolean>(false)

    const {
        config: {
            imageWidth = 285,
            pagination = true,
            navigation = true
        },
        lists,
    } = data;

    const onClickItem = (item: IReview) => {
        setReviewItem(item)
        setDetailVisible(true)
    }

    const onCloseDetailModal = () => {
        setDetailVisible(false)
    }

    return (
        <div id={moduleElementId}
             data-t-mod={moduleCode}
             className={homeStyles.wrapper}
             style={getWrapStyle(data)}
        >

            <ModuleTitle
                className={cn(titleStyles.title, homeStyles.title)}
                text={data.title}
                link={data.readMoreLink}
                linkText={data.readMoreTitle}
                moduleCode={moduleCode}
            />

            <ReviewDetailModal
                reviewItem={reviewItem}
                visible={detailVisible}
                onClose={onCloseDetailModal}
            />

            <div>
                <ThemeSwiper
                    ref={swiperRef}
                    className={cn(
                        styles.swiper,
                        { [styles['swiper-with-pagination']]: navigation && !pagination },
                        { [styles['swiper-with-both']]: navigation && pagination }
                    )}
                    slidesPerView={'auto'}
                    slidesPerGroup={1}
                    spaceBetween={24}
                    // centeredSlides
                    list={lists}
                    pagination={pagination}
                    navigation={navigation}
                    render={(item: IReview) => (
                        <div
                            className={cn(styles.item, 'pointer')}
                            onClick={() => onClickItem(item)}
                        >
                            <Image
                                fit={'cover'}
                                src={item?.images?.[0].picUrl}
                                width={imageWidth}
                                height={imageWidth}
                            />

                            <div className={styles.info}>
                                <p className={styles.title}>{item.title}</p>
                                <p className={styles.content}>{item.content}</p>
                                <div className={cn(styles['name-rate'], 'flex flex-justify')}>
                                    <span className={styles['user-name']}>{stringReplaceMiddleChars(item.userName || '')}</span>

                                    <Rate value={item.rate} starSize={15}/>

                                </div>
                            </div>
                        </div>
                    )}
                />
            </div>

        </div>
    );
};

export default React.memo(SwiperReviews);